import {Component, inject, OnInit} from '@angular/core';
import {
  ControlContainer,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
} from '@angular/forms';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {EmSelectOperandModule} from '@em/shared/mapping-engine/feature';
import {EmSelectModule, EmMoreInfoModule} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'em-most-used-price-filter',
  templateUrl: './most-used-price-filter.component.html',
  styleUrls: ['./most-used-price-filter.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    EmSelectModule,
    EmSelectOperandModule,
    MatSlideToggleModule,
    EmMoreInfoModule,
  ],
})
export class EmMostUsedPriceFilterComponent implements OnInit {
  private readonly _controlContainer = inject(ControlContainer);
  formGroup: UntypedFormGroup | null | undefined;

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as UntypedFormGroup;
  }
}
